import { createSlice } from "@reduxjs/toolkit";

const storedBot = localStorage.getItem("botInfo");

const initialState = storedBot
    ? JSON.parse(storedBot)
    : {
        name: "",      // نام فارسی
        username: "",  // نام انگلیسی
    };
// const initialState = {
//     name: "",      // نام فارسی
//     username: "",  // نام انگلیسی
//   };
const botSlice = createSlice({
    name: "bot",
    initialState,
    reducers: {
        setBotInfo: (state, action) => {
            const botData = {
                name: action.payload.name,
                username: action.payload.username,
            };

              localStorage.setItem("botInfo", JSON.stringify(botData));

            return botData;
        },

        clearBotInfo: () => {
              localStorage.removeItem("botInfo");
            return {
                name: "",
                username: "",
            };
        },
    },
});

export const { setBotInfo, clearBotInfo } = botSlice.actions;
export default botSlice.reducer;
